import { useQuery, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { UserInterface } from '../interfaces/user_interface';
import { UserRepositoryImpl } from '../../data/repository/user_repository_impl';
import { UserLocalService } from '../../data/data_source/local/user_local_service';

export const useGetMyUserProfile = (enabled: boolean = true) => {
  const repository = new UserRepositoryImpl();
  const userLocalService = new UserLocalService();

  const query = useQuery<UserInterface, AxiosError>({
    queryKey: ['userProfile'],
    queryFn: async () => {
      const data = await repository.getMyUserProfile();
      userLocalService.setMeCached(data);
      return data;
    },
    retry: 2,
    enabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    initialData: () => {
      const cached = userLocalService.getMeCached();
      return cached || undefined;
    },
  });

  return query;
};

export const useUpdateCareerStatus = () => {
  const repository = new UserRepositoryImpl();

  return useMutation<boolean, AxiosError, { status: string }>({
    mutationFn: ({ status }: { status: string }) => repository.updateMyCareerStatus(status),
  });
};
